import { Circle, CreditCard } from 'react-feather'

export default [
	{
		id: 'money',
		title: 'Tiền tệ',
		icon: <CreditCard size={20} />,
		children: [
			{
				id: 'payment-card',
				title: 'Nạp thẻ cào',
				icon: <Circle size={12} />,
				navLink: '/money/card'
			},
			{
				id: 'payment-atm',
				title: 'Nạp ATM/MOMO',
				icon: <Circle size={12} />,
				navLink: '/money/payment'
			},
			{
				id: 'gcent-2-wcoin',
				title: 'Đổi GCent > WCoin',
				icon: <Circle size={12} />,
				navLink: '/money/gcent-to-wcoin'
			},
			{
				id: 'history',
				title: 'Lịch sử nạp tiền',
				icon: <Circle size={12} />,
				navLink: '/money/history'
			}
		]
	}
]
